module.exports = __webpack_public_path__ + "static/4-2c124e69ad601f01101c9d1f62a01631.jpeg";